export default "__VITE_ASSET__CxsZ4GWj__"